/**
 * Deep link to Meta Ads Manager with a campaign pre-selected (Campaigns tab).
 * Matches URLs produced by the product, e.g.
 * `.../manage/campaigns?act=...&selected_campaign_ids=...&nav_entry_point=...&nav_source=ads_manager`
 * ([example](https://adsmanager.facebook.com/adsmanager/manage/campaigns?act=1381901869498267&business_id=1762929743811927&nav_entry_point=ads_ecosystem_navigation_menu&selected_campaign_ids=120243588257450435&nav_source=ads_manager)).
 */
export function buildMetaAdsManagerCampaignUrl(input: {
  accountId: string;
  campaignExternalId: string;
  businessId?: string;
}): string {
  const act = input.accountId.replace(/^act_/i, "").trim();
  const selectedId = input.campaignExternalId.trim();
  const parts: string[] = [
    `act=${encodeURIComponent(act)}`,
    `selected_campaign_ids=${encodeURIComponent(selectedId)}`,
    `nav_entry_point=${encodeURIComponent("ads_ecosystem_navigation_menu")}`,
    `nav_source=${encodeURIComponent("ads_manager")}`,
  ];
  const bid = input.businessId?.replace(/\D/g, "").trim();
  if (bid) parts.push(`business_id=${encodeURIComponent(bid)}`);
  return `https://adsmanager.facebook.com/adsmanager/manage/campaigns?${parts.join("&")}`;
}

/** Business Suite Partnership Ads Hub — Ad partners tab (no account context). */
export const META_BUSINESS_SUITE_PARTNERSHIP_ADS_HUB_URL =
  "https://business.facebook.com/partnership_ads_hub/ad_partners/";

/**
 * Deep link to Partnership Ads Hub → Ad partners for the brand ad account.
 * Matches URLs opened from Meta Business Suite, e.g.
 * `https://business.facebook.com/partnership_ads_hub/ad_partners/?ad_account_id=…&business_id=…&nav_ref`
 */
export function buildMetaPartnershipAdsHubUrl(input?: {
  accountId?: string;
  businessId?: string;
}): string {
  const adAccountId = input?.accountId?.replace(/^act_/i, "").trim();
  const businessId = input?.businessId?.replace(/\D/g, "").trim();
  if (!adAccountId && !businessId) {
    return META_BUSINESS_SUITE_PARTNERSHIP_ADS_HUB_URL;
  }
  const parts: string[] = [];
  if (adAccountId) {
    parts.push(`ad_account_id=${encodeURIComponent(adAccountId)}`);
  }
  if (businessId) {
    parts.push(`business_id=${encodeURIComponent(businessId)}`);
  }
  parts.push("nav_ref");
  return `${META_BUSINESS_SUITE_PARTNERSHIP_ADS_HUB_URL}?${parts.join("&")}`;
}
